export default [
  {
    symbol_coin: 'DAI',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '68589',
    market_cap: '604201973',
    name_coin: 'Multi-Collateral Dai',
    number_of_markets: '138',
    percent_change_24hr: '0.11',
    price: '1.0103323479',
    total_supply: '598023211.5372158',
    uuid: 'MoTuySvg7',
    volume: '67415787',
  },
  {
    symbol_coin: 'VET',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '19',
    market_cap: '771025471',
    name_coin: 'VeChain',
    number_of_markets: '139',
    percent_change_24hr: '-9.55',
    price: '0.0119881607',
    total_supply: '85985041177',
    uuid: 'FEbS54wxo4oIl',
    volume: '163108342',
  },
  {
    symbol_coin: 'BSV',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '4875',
    market_cap: '2974335441',
    name_coin: 'Bitcoin SV',
    number_of_markets: '314',
    percent_change_24hr: '-8.34',
    price: '160.4974702687',
    total_supply: '18531977.08192325',
    uuid: 'VcMY11NONHSA0',
    volume: '859735467',
  },
  {
    symbol_coin: 'ATOM*',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '4966',
    market_cap: '1169600656',
    name_coin: 'Cosmos',
    number_of_markets: '95',
    percent_change_24hr: '-9.15',
    price: '4.9034491839',
    total_supply: '260368298.1563',
    uuid: 'Knsels4_Ol-Ny',
    volume: '158006781',
  },
  {
    symbol_coin: 'YFI',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '71246',
    market_cap: '637067698',
    name_coin: 'yearn.finance',
    number_of_markets: '103',
    percent_change_24hr: '-9.5',
    price: '21258.4998494376',
    total_supply: '30000.0',
    uuid: 'dYuh_N0n1',
    volume: '854402707',
  },
  {
    symbol_coin: 'OMG',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '24',
    market_cap: '530141632',
    name_coin: 'OmiseGo',
    number_of_markets: '386',
    percent_change_24hr: '-11.45',
    price: '3.780471069',
    total_supply: '140245398.24513277',
    uuid: '_tpssiAXwrHfr',
    volume: '526277351',
  },
  {
    symbol_coin: 'HT',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '71',
    market_cap: '980364889',
    name_coin: 'Huobi Token',
    number_of_markets: '137',
    percent_change_24hr: '0.39',
    price: '4.7093893705',
    total_supply: '50.',
    uuid: 'DXwP4wF9ksbBO',
    volume: '179739776',
  },
  {
    symbol_coin: 'LTC',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '7',
    market_cap: '2942861829',
    name_coin: 'Litecoin',
    number_of_markets: '2903',
    percent_change_24hr: '-7.2',
    price: '44.8740183035',
    total_supply: '65580528.33766152',
    uuid: 'D7B1x_ks7WhV5',
    volume: '1186920342',
  },
  {
    symbol_coin: 'HEX',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '5331',
    market_cap: '1291916844',
    name_coin: 'HEX',
    number_of_markets: '21',
    percent_change_24hr: '-6.86',
    price: '0.0036571235',
    total_supply: '353260484152.72144',
    uuid: '9K7m6ufraZ6gh',
    volume: '1580462',
  },
  {
    symbol_coin: 'SNX',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '10883',
    market_cap: '446914210',
    name_coin: 'Synthetix Network',
    number_of_markets: '109',
    percent_change_24hr: '-9.45',
    price: '4.3404226728',
    total_supply: '203851539.53646886',
    uuid: 'sgxZRXbK0FDc',
    volume: '51311840',
  },
  {
    symbol_coin: 'EOS',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '5',
    market_cap: '2291806273',
    name_coin: 'EOS',
    number_of_markets: '629',
    percent_change_24hr: '-5.13',
    price: '2.4727592378',
    total_supply: '1023255279.3293',
    uuid: 'iAzbfXiBBKkR6',
    volume: '1076092740',
  },
  {
    symbol_coin: 'USDC',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '1760',
    market_cap: '2550306702',
    name_coin: 'USDC',
    number_of_markets: '697',
    percent_change_24hr: '0.03',
    price: '1.0009460737',
    total_supply: '2547902205.304902',
    uuid: 'aKzUVe4Hh_CON',
    volume: '599453895',
  },
  {
    symbol_coin: 'CRO',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '10296',
    market_cap: '3004369026',
    name_coin: 'Crypto.com Chain',
    number_of_markets: '124',
    percent_change_24hr: '-2.94',
    price: '0.1473389504',
    total_supply: '10.',
    uuid: '65PHZTpmE55b',
    volume: '77620361',
  },
  {
    symbol_coin: 'THETA',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '96',
    market_cap: '680541666',
    name_coin: 'Theta Token',
    number_of_markets: '72',
    percent_change_24hr: '-3.89',
    price: '0.6805416655',
    total_supply: '10.',
    uuid: 'B42IRxNtoYmwK',
    volume: '74786721',
  },
  {
    symbol_coin: 'LEO*',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '14755',
    market_cap: '1246462418',
    name_coin: 'LEO',
    number_of_markets: '31',
    percent_change_24hr: '-0.79',
    price: '1.264202667',
    total_supply: '995239762',
    uuid: 'mqtUpyBxu8O8',
    volume: '16430824',
  },
  {
    symbol_coin: 'DOT***',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '71983',
    market_cap: '3686847908',
    name_coin: 'Polkadot',
    number_of_markets: '81',
    percent_change_24hr: '-9.33',
    price: '4.0782708277',
    total_supply: '984971466',
    uuid: '25W7FG7om',
    volume: '455136737',
  },
  {
    symbol_coin: 'XEM',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '17',
    market_cap: '812921289',
    name_coin: 'NEM',
    number_of_markets: '182',
    percent_change_24hr: '-3.39',
    price: '0.1148712125',
    total_supply: '8999999999',
    uuid: 'DZtb-6X8yCx0h',
    volume: '34477587',
  },
  {
    symbol_coin: 'WBTC***',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '10607',
    market_cap: '981017960',
    name_coin: 'Wrapped BTC',
    number_of_markets: '45',
    percent_change_24hr: '-3.32',
    price: '10596.0570527586',
    total_supply: '92583.30290003',
    uuid: 'x4WXHge-vvFY',
    volume: '21443073',
  },
  {
    symbol_coin: 'BTC',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '1',
    market_cap: '195080675249',
    name_coin: 'Bitcoin',
    number_of_markets: '19526',
    percent_change_24hr: '-3.13',
    price: '10541.5468736282',
    total_supply: '18505887',
    uuid: 'Qwsogvtv82FCd',
    volume: '18997299641',
  },
  {
    symbol_coin: 'LEND',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '227',
    market_cap: '668474965',
    name_coin: 'Aave',
    number_of_markets: '107',
    percent_change_24hr: '-8.87',
    price: '0.533063077',
    total_supply: '1299999941.7031682',
    uuid: 'W835aIlO9Ngzn',
    volume: '145415965',
  },
  {
    symbol_coin: 'COMP**',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '70838',
    market_cap: '467374808',
    name_coin: 'Compound',
    number_of_markets: '42',
    percent_change_24hr: '-10.98',
    price: '121.9829180023',
    total_supply: '10.',
    uuid: '7Dg6y_Ywg',
    volume: '40161871',
  },
  {
    symbol_coin: 'CDAI',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '66208',
    market_cap: '1171082146',
    name_coin: 'Compound Dai',
    number_of_markets: '2',
    percent_change_24hr: '0.72',
    price: '0.0210626676',
    total_supply: '55599896978.00264',
    uuid: 'lT__vMO7l',
    volume: '73315',
  },
  {
    symbol_coin: 'XLM',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '6',
    market_cap: '1436441841',
    name_coin: 'Stellar',
    number_of_markets: '710',
    percent_change_24hr: '-6.37',
    price: '0.0710915427',
    total_supply: '49999999738.63592',
    uuid: 'f3iaFeCKEmkaZ',
    volume: '166373758',
  },
  {
    symbol_coin: 'ETH',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '2',
    market_cap: '38694966435',
    name_coin: 'Ethereum',
    number_of_markets: '14308',
    percent_change_24hr: '-5.92',
    price: '344.7123699371',
    total_supply: '112842891.8115',
    uuid: 'razxDUgYGNAdQ',
    volume: '9956750686',
  },
  {
    symbol_coin: 'UMA',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '69380',
    market_cap: '418707721',
    name_coin: 'UMA',
    number_of_markets: '60',
    percent_change_24hr: '-15.71',
    price: '7.5922204427',
    total_supply: '101009348.65799929',
    uuid: '6Cnl5FOCZ',
    volume: '19738928',
  },
  {
    symbol_coin: 'ADA',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '9',
    market_cap: '2909138957',
    name_coin: 'Cardano',
    number_of_markets: '188',
    percent_change_24hr: '-8.46',
    price: '0.0935039095',
    total_supply: '31112484745',
    uuid: 'qzawljRxB5bYu',
    volume: '379084355',
  },
  {
    symbol_coin: 'BCH',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '4',
    market_cap: '4066107260',
    name_coin: 'Bitcoin Cash',
    number_of_markets: '900',
    percent_change_24hr: '-5.23',
    price: '219.3971613736',
    total_supply: '18533089.64679986',
    uuid: 'ZlZpzOJo43mIo',
    volume: '1331358239',
  },
  {
    symbol_coin: 'LINK',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '59',
    market_cap: '3565880604',
    name_coin: 'Chainlink',
    number_of_markets: '335',
    percent_change_24hr: '-9.56',
    price: '9.2258537876',
    total_supply: '10.',
    uuid: 'VLqpJwogdhHNb',
    volume: '1209049940',
  },
  {
    symbol_coin: 'DGB',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '30',
    market_cap: '340214174',
    name_coin: 'DigiByte',
    number_of_markets: '201',
    percent_change_24hr: '-5.3',
    price: '0.0258737679',
    total_supply: '13149.',
    uuid: 'q9yo3-QDbH-lM',
    volume: '11939581',
  },
  {
    symbol_coin: 'OKB',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '1524',
    market_cap: '1705745442',
    name_coin: 'OKB',
    number_of_markets: '131',
    percent_change_24hr: '-2.29',
    price: '6.1911825263',
    total_supply: '30.',
    uuid: 'PDKcptVnzJTmN',
    volume: '89060390',
  },
  {
    symbol_coin: 'XMR',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '10',
    market_cap: '1731674872',
    name_coin: 'Monero',
    number_of_markets: '636',
    percent_change_24hr: '-9.8',
    price: '97.7474102649',
    total_supply: '17715813.310651004',
    uuid: '3mVx2FX_iJFp5',
    volume: '382502084',
  },
  {
    symbol_coin: 'DASH',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '13',
    market_cap: '638277845',
    name_coin: 'Dash',
    number_of_markets: '659',
    percent_change_24hr: '-7.0',
    price: '65.5394395227',
    total_supply: '9738835.87446738',
    uuid: 'C9DwH-T7MEGmo',
    volume: '222603803',
  },
  {
    symbol_coin: 'ZEC',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '21',
    market_cap: '633894370',
    name_coin: 'Zcash',
    number_of_markets: '383',
    percent_change_24hr: '-8.43',
    price: '62.3950547674',
    total_supply: '10159368.75',
    uuid: 'aRGRWLf2RYNq4',
    volume: '409644356',
  },
  {
    symbol_coin: 'TUSD',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '274',
    market_cap: '514987571',
    name_coin: 'TrueUSD',
    number_of_markets: '558',
    percent_change_24hr: '-0.24',
    price: '1.0003186435',
    total_supply: '514823525.9442424',
    uuid: '1ZZI6g5k5royD',
    volume: '77735399',
  },
  {
    symbol_coin: 'FTT**',
    timestamp: '2020-10-02T15:29:00.000Z',
    id: '62569',
    market_cap: '327632919',
    name_coin: 'FTX Token',
    number_of_markets: '14',
    percent_change_24hr: '-0.92',
    price: '3.5260994519',
    total_supply: '343788864.159496',
    uuid: 'NfeOYfNcl',
    volume: '7395352',
  },
  {
    symbol_coin: 'BNB',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '14',
    market_cap: '3465020890',
    name_coin: 'Binance Coin',
    number_of_markets: '586',
    percent_change_24hr: '-4.36',
    price: '27.08208506',
    total_supply: '140345602',
    uuid: 'WcwrkfNI4FUAe',
    volume: '967085611',
  },
  {
    symbol_coin: 'XTZ',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '18',
    market_cap: '1553907310',
    name_coin: 'Tezos',
    number_of_markets: '155',
    percent_change_24hr: '-7.98',
    price: '2.0852065014',
    total_supply: '851486447.251678',
    uuid: 'fsIbGOEJWbzxG',
    volume: '118100687',
  },
  {
    symbol_coin: 'XRP',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '3',
    market_cap: '10261063644',
    name_coin: 'XRP',
    number_of_markets: '828',
    percent_change_24hr: '-4.02',
    price: '0.2327319542',
    total_supply: '99990976125',
    uuid: '-l8Mn2pVlRs-p',
    volume: '1024961936',
  },
  {
    symbol_coin: 'CEL',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '4303',
    market_cap: '373776521',
    name_coin: 'Celsius Network',
    number_of_markets: '22',
    percent_change_24hr: '-4.08',
    price: '1.0357112879',
    total_supply: '695658160.9671',
    uuid: 'rk5XwL6mIjUDp',
    volume: '4301285',
  },
  {
    symbol_coin: 'BUSD',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '14066',
    market_cap: '518610758',
    name_coin: 'BUSD ',
    number_of_markets: '71',
    percent_change_24hr: '0.04',
    price: '1.0009728495',
    total_supply: '518106717.88',
    uuid: 'vSo2fu9iE1s0Y',
    volume: '122630333',
  },
  {
    symbol_coin: 'ETC',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '16',
    market_cap: '602687517',
    name_coin: 'Ethereum Classic',
    number_of_markets: '360',
    percent_change_24hr: '-4.63',
    price: '5.1815873368',
    total_supply: '107988299',
    uuid: 'hnfQfsYfeIGUQ',
    volume: '254347481',
  },
  {
    symbol_coin: 'WETH',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '5858',
    market_cap: '2562515825',
    name_coin: 'Wrapped Ether',
    number_of_markets: '245',
    percent_change_24hr: '-5.92',
    price: '345.1902306681',
    total_supply: '7423488.861678172',
    uuid: 'Mtfb0obXVh59u',
    volume: '428027017',
  },
  {
    symbol_coin: 'UNI***',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '72821',
    market_cap: '879742290',
    name_coin: 'Uniswap',
    number_of_markets: '66',
    percent_change_24hr: '-10.01',
    price: '3.9423262928',
    total_supply: '10.',
    uuid: '_H5FVG9iW',
    volume: '451637058',
  },
  {
    symbol_coin: 'NEO',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '15',
    market_cap: '1312715562',
    name_coin: 'NEO',
    number_of_markets: '348',
    percent_change_24hr: '-7.95',
    price: '18.1817325417',
    total_supply: '10.',
    uuid: 'cVaOmQWainv7g',
    volume: '477292851',
  },
  {
    symbol_coin: 'MIOTA',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '12',
    market_cap: '726980363',
    name_coin: 'IOTA',
    number_of_markets: '64',
    percent_change_24hr: '-7.03',
    price: '0.2615479197',
    total_supply: '2779530283',
    uuid: 'LtWwuVANwRzV_',
    volume: '14701440',
  },
  {
    symbol_coin: 'USDT',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '8',
    market_cap: '15566952535',
    name_coin: 'Tether USD',
    number_of_markets: '10033',
    percent_change_24hr: '-0.03',
    price: '1.0013613714',
    total_supply: '15708143613.99',
    uuid: 'HIVsRcGKkPFtW',
    volume: '28017858598',
  },
  {
    symbol_coin: 'TRX',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '11',
    market_cap: '1653086728',
    name_coin: 'TRON',
    number_of_markets: '517',
    percent_change_24hr: '-5.88',
    price: '0.0249936637',
    total_supply: '99281283754',
    uuid: 'qUhEFk1I61atv',
    volume: '625729690',
  },
  {
    symbol_coin: 'DOGE',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '20',
    market_cap: '327535328',
    name_coin: 'Dogecoin',
    number_of_markets: '2345',
    percent_change_24hr: '-3.07',
    price: '0.0025893314',
    total_supply: '126494170446.09227',
    uuid: 'a91GCGd_u96cF',
    volume: '53161681',
  },
  {
    symbol_coin: 'MKR',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '22',
    market_cap: '499556776',
    name_coin: 'Maker',
    number_of_markets: '181',
    percent_change_24hr: '-6.65',
    price: '547.747275956',
    total_supply: '1005576.7463295957',
    uuid: 'qFakph2rpuMOL',
    volume: '35580505',
  },
  {
    symbol_coin: 'ALGO',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '14585',
    market_cap: '887813553',
    name_coin: 'Algorand',
    number_of_markets: '110',
    percent_change_24hr: '-11.98',
    price: '0.3178493554',
    total_supply: '10.',
    uuid: 'TpHE2IShQw-sJ',
    volume: '111112874',
  },
  {
    symbol_coin: 'ONT',
    timestamp: '2020-10-02T15:29:11.000Z',
    id: '26',
    market_cap: '375777349',
    name_coin: 'Ontology',
    number_of_markets: '144',
    percent_change_24hr: '-8.94',
    price: '0.58959231',
    total_supply: '10.',
    uuid: 'itpeyyriqoiG2',
    volume: '135479732',
  },
];
